import {
    LocaleService,
    type Translations,
} from '@frontend/services/LocaleService'

// Словарь приложения для текущей локали.
export function trans(): Translations {
    return LocaleService.translations
}
